module.exports = __webpack_public_path__ + "1db082a0ea20bba6c2338dbf058d46e3.png";